import { css, fresponsive, styled } from "library/styled"
import colors from "styles/colors"
import textStyles from "styles/text"

export function QuoteBox({
	data,
}: {
	data: { text?: string; author?: string }
}) {
	const { text, author } = data
	if (!text) return null

	return (
		<Wrapper>
			<Quote>“</Quote>
			<Text>{text}</Text>
			{author && <Author>{author}</Author>}
		</Wrapper>
	)
}

const Wrapper = styled("div", {
	...fresponsive(css`
		background: ${colors.green400};
		padding: 32px;
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 32px;
		border-radius: 16px;
	`),
})

const Quote = styled("p", {
	...fresponsive(css`
		${textStyles.custom.h4};
		color: ${colors.greenAccent};
		height: 17px;
	`),
})

const Text = styled("p", {
	...fresponsive(css`
		${textStyles.bodyL};
		color: ${colors.white};
	`),
})

const Author = styled("cite", {
	...fresponsive(css`
		${textStyles.titleL};
		color: ${colors.greenAccent};
		display: block;
		margin-top: 8px;
	`),
})
